// all these utility methods are for whole app. generalization purpose

// export const getAppUrl = () => {
//     var appUrl = "http://stag.lincolnmethod.com/" // depends on white label
//     return appUrl;
// }

export const getBaseUrl = () => {
  // var protocol = window.location.host.indexOf('localhost') > -1 ? "https:" : window.location.protocol;
  // var baseUrl = protocol + "//dashboard.lincolnmethod.com" // depends on white label
  // var baseUrl = "https://stag-dashboard.lincolnmethod.com"; // Staging Link
  var baseUrl = "https://dashboard.lincolnmethod.com"; //live link
  // var baseUrl = "https://neuro-lincoln.local";//local API
  return baseUrl;
};

export const getNestUrl = () => {
  // var baseUrl = "http://localhost:5000"; //local link
  var baseUrl = "https://lm-api-nest.lincolnmethod.com"; //live link
  return baseUrl;
};

export const logOut = () => {
  localStorage.setItem("loginData", ""); // clear loginData localstorage
  return true;
};

export const validateEmailAddress = (email) => {
  // validates email address (return boolean)
  var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return regex.test(email);
};

export const validatePhone = (phone) => {
  // validates email address (return boolean)
  var regex =
    /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/;
  return regex.test(phone);
};

export const isMobileBrowser = () => {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const reserveBackOnMobile = (check) => {
  if (check) {
    window.location.hash = "reserve";
    window.onhashchange = function (event) {
      window.location.hash = "reserve";
    };
  } else {
    window.onhashchange = function (event) {
      window.location.hash = "";
    };
  }
};

export const validateIfTeacher = () => {
  try {
    var loginStatus = localStorage.getItem("loginData");
    if (loginStatus != null && typeof JSON.parse(loginStatus) === "object") {
      var isteacher = JSON.parse(loginStatus).is_teacher;
      if (isteacher == 1) {
        return true;
      } else {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }
};

export const validateUserType = (studentParamId) => {
  try {
    var strArr = studentParamId.split("#/");

    var loginStatus = localStorage.getItem("loginData");
    if (loginStatus != null && typeof JSON.parse(loginStatus) === "object" && strArr[1] == "") {
      var userType = JSON.parse(loginStatus).user_type;
      if (userType == 0) {
        return "Student";
      } else if (userType == 1) {
        return "Teacher";
      } else if (userType == 2) {
        return "Em";
      } else {
        return "Student";
      }
    } else {
      if (strArr[1] == "") return "/";
      else return "Student";
    }
  } catch (e) {
    console.log(e);
  }
};

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const validateMonth = (date) => {
  let newDate = new Date(date);
  if (Number.isNaN(newDate.getMonth())) {
    let arr = date.split(/[- :]/);
    newDate = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    console.log("Date", newDate);
    var monthName = monthNames[newDate.getMonth()];
    return monthName.slice(0, 3);
  } else {
    var newdemo = new Date(date).toLocaleString("default", {
      month: "short",
    });

    return newdemo;
  }
};
export const validateDate = (date) => {
  let newDate = new Date(date);
  if (Number.isNaN(newDate.getMonth())) {
    let arr = date.split(/[- :]/);
    newDate = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    console.log("Date", newDate);
    return newDate.getDate();
  } else {
    var newdemo = new Date(date).getDate();

    return newdemo;
  }
};

export const successColor = "#01ac8a";

export const daysName = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const daysNameEvaluation = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const makeFirstLetterCapital = (string) => {
  if (string != null) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else {
    return "-";
  }
};

export const imageLink = (imageName) => {
  let url = `https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${imageName}`;
  return url;
};

export const dummyStudentData = [
  {
    name: "Sophie Saleem",
    img: "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1601285083_up_66450683.jpeg",
    contactNo: "+923742997888 ",
    email: "saleem@gmail.com",
    date: "12th Jan 20",
    program: "Math Online Classes - Grade 2",
  },
  {
    name: "Maraib Shah",
    img: "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1594283790_up_547807745.jpeg",
    contactNo: "+923422181129",
    email: "maraib@gmail.com",
    date: "23rd March 22",
    program: "English Online Classes - Grade 2",
  },
  {
    name: "Abdul Rehman",
    img: "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1652681461_up_446728853.jpeg",
    contactNo: "+923422231129",
    email: "Rehman@gmail.com",
    date: "23rd March 22",
    program: "Science Online Classes - Grade 2",
  },
  {
    name: "Marium Tahir",
    img: "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1652681452_up_600926738.jpeg",
    contactNo: "+923422181129",
    email: "ahmeMariumdkhan@gmail.com",
    date: "23rd March 22",
    program: "Math Online Classes - Grade 2",
  },
  {
    name: "Ibrahim Hassan",
    img: "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1623823908_up_400331666.jpeg",
    contactNo: "+923422181129",
    email: "Ibrahim@gmail.com",
    date: "23rd March 22",
    program: "Math Online Classes - Grade 2",
  },
  {
    name: "Muhammad Usman",
    img: "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1602072791_up_963791841.jpeg",
    contactNo: "+923422181129",
    email: "Usman@gmail.com",
    date: "23rd March 22",
    program: "Math Online Classes - Grade 2",
  },
  {
    name: "Zaimal Ali",
    img: "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1653543466_up_98372113.jpeg",
    contactNo: "+923422181129",
    email: "Zaimal@gmail.com",
    date: "23rd March 22",
    program: "Math Online Classes - Grade 2",
  },
  {
    name: "Haiqa Waziri",
    img: "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1667801552_up_7441262.jpeg",
    contactNo: "+923422181129",
    email: "Haiqa@gmail.com",
    date: "23rd March 22",
    program: "Math Online Classes - Grade 2",
  },
];
